import jaLocal from 'vant/lib/locale/lang/ja-JP'

const ja = {
  300000: '作成できる紹介リンクの残りの数',
  300001: '2022新年送禮',
  300002: 'SuperEx和你一起過新年',
  300003: '尊敬的SuperEx用戶：<br>為慶祝SuperEx在新年之際盛大上線,<br>平台將隨機空投送出價值1,000,000 USDT新年大禮包。<br>具體活動如下：',
  300004: '活動時間<br>加拿大時間：2022年01月01日00：00-02月15日23：59',
  300005: '活動一：分享海報獲空投',
  300006: '分享活動海報至＞1000人的telegram加密貨幣群組，並附言“百萬豪禮大派送，SuperEx和你一起過新年！或分享活動海報至個人Tiwwer，置頂並附言“百萬豪禮大派送，SuperEx和你一起過新年！”上傳截圖給客服，將有機會獲得5 ET（價值5 USDT）。',
  300007: '活動二：邀新獲VIP',
  300008: '獲得期間，用戶通過邀請好友新注冊並成功入金≥100 USDT即為有效邀請人數。成功邀請人數越多，所獲VIP等級越高。有效期（30天）',
  300009: '活動三：新用戶充值送',
  300010: '活動期間，新注冊用戶淨充值金額達到一下區間並完成一筆交易，即可獲得ET獎勵。（淨充值金額在活動結束前以USDT結算）活動期間，新注冊用戶淨充值金額達到一下區間並完成一筆交易，即可獲得ET獎勵。（淨充值金額在活動結束前以USDT結算）',
  300011: '注意事項：',
  300012: '1.每位參與用戶只能獲得一次獎勵 <br>2.所有參與用戶默認遵守SuperEx服務條款，如發現違規將立即停止其活動資格 <br>3.SuperEx有權在不提早通知用戶的情況下修改本次活動的條款 <br>4.SuperEx將取消不合規用戶活動參與資格並停用相關SuperEx賬戶使用 <br>5.SuperEx保留本次活動最終解釋權',
  300013: '立即分享',
  300014: 'SuperEx团队',
  300015: '2022年01月01日',
  300016: '更多信息關注SuperEx官網：SuperEx.com',
  300017: '淨充值金額（{coin}）',
  300018: '獎勵金（{coin}）',
  300019: '180天',
  300020: '淨充值=總入金金額-總出金金額',
  300021: 'ET持倉數量',
  300022: 'Maker/Taker',
  300023: '有效邀請人數',
  300024: '贈送有效期',
  300025: '活動獲取條件',
  300026: '注：所有贈送的VIP等級均無需ET持倉要求。',
  300027: 'コピー成功',
  300028: 'コピー失敗',

  300029: 'ダウンロード SuperEx APP',
  300030: 'しばらくしない',
  300031: 'SuperExアカウントの作成',
  300032: '若您已有SuperEx賬戶，請先登錄',
  300033: 'メール',
  300034: 'モバイル',
  300035: '携帯電話番号',
  300036: 'パスワード',
  300037: '推薦者ID（オプション）',
  300038: '私は読んで同意しました',
  300039: 'SuperExサービス利用規約',
  300040: '18歳以上であり、SuperEx利用規約に同意する',
  300041: '新規登録',
  300042: 'セキュリティ認証',
  300043: '市外局番を選択する',
  300044: '検索',
  300045: '携帯番号を入力してください',
  300046: '正しい携帯番号を入力してください',
  300047: 'メールアドレスを入力してください',
  300048: '有効なメールアドレスを入力してください',
  300049: 'パスワードを入力してください',
  300050: '8文字以上、アルファベット大文字、数字を組み合わせてください',
  300051: 'メールアドレス認証コード',
  300052: 'SMS認証コード',
  300053: 'Google/Microsoft認証コード',
  300054: 'Google/Microsoft認証',
  300055: 'アカウント安全のために、次の確認操作を完了してください',
  300056: '提出する',
  300057: '6桁の認証コードがお使いの携帯電話{phone}に送信されます',
  300058: '6桁の認証コードがお使いのメール{email}に送信されます',
  300059: '6 桁の SuperEx/Google/Microsoft 確認コードを入力してください',
  300060: '6桁の認証コードを入力してください',
  300061: '認証コードを送信します',
  300062: '{timeout}秒後に再送します',
  300063: '言語',
  300064: '監査中',
  300065: '英字または句読点を入力してください',


  300066: 'ミッションセンター',
  300067: 'コミッションランキング大作戦',
  300068: '最大 <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1つのBTC</em> を待っています！',
  300069: '招待する',
  300070: 'ランキング',
  300071: 'アンロックルール',
  300072: '今すぐ行動してETを取得する',
  300073: 'コミッションランキング大作戦、最高1 BTCを獲得できます',
  300074: '取引を完了し、ETのロックを解除します',
  300075: '以上のすべてのタスクを完了すると、アカウントはホワイトリストに登録され、オフィシャルはホワイトリストに登録されたユーザーに大量のETをランダムに報酬として提供します。',
  300076: '日ランキング',
  300077: '累計ランキング',
  300078: 'サービス利用規約',
  300079: '私の報酬',

  300080: 'ロック数',
  300081: 'アンロック数',
  300082: 'ロック解除数量=手数料*ロックを解除の難易度/ET価格',
  300083: '取引に行く',
  300084: 'ランキング',
  300085: 'アカウント',
  300086: 'コミッション数',
  300087: '注：当日のランキングはその日の0:00まで計算され、報酬は翌日に発行されます。データは正しくない可能性があり、情報提供のみを目的としています。',
  300088: '注：イベント終了後3営業日以内に発行されます。参考のためにデータに誤差がある可能性があります。',
  300089: 'もっと見る',

  300090: '片付ける',
  300091: 'あなたのアカウントはすでにホワイトリストに登録されています！',
  300092: '{type}アカウントを入力してください',
  300093: '情報を入力',
  300094: 'Twitterでフォローする',
  300095: 'telegramに参加する',
  300096: '今すぐ最初の入金をしてください',
  300097: '今すぐ最初の現物取引を行う',
  300098: 'すぐに最初の先物契約取引を行う',
  300099: '今すぐ友達を紹介する一緒に参加する',

  300100: '友達が取引するのを手伝ってください',
  300101: 'お友達ともっと特典をもらえましょう',
  300102: 'コイン入金に行く',
  300103: 'フォローに行く',
  300104: '受け取りに行く',
  300105: '受け取った（回）',
  300106: '一時的に利用できません',
  300107: 'に参加',
  300108: 'データなし',
  300109: '完了しました',
  300110: '今すぐ行動してSCSを取得し、友達を招待してもっと報酬をもらえます',
  300111: 'キャンセル',
  300112: '提出する',
  300113: '重複しないでください',
  300114: '現在、ミッションはありません',
  300115: 'より多くの任務をご期待してください',
  300116: 'より多くのイベントをご期待してください',
  300117: 'Twitterアカウントをバインドして取得します',
  300118: 'Telegramアカウントをバインドして取得します',
  300119: 'あきらめる',
  300120: '今すぐSuperExにサインアップ',
  300121: '登録する',
  300122: '有効期限',
  300123: '白書',

  300124: '謎の箱',
  300125: '<em class="normal bold" style="color: #FFC72B">100%</em>の当選率、友達とのサプライズオープンボックス',
  300126: 'ルール',

  300127: 'ブラインドボックスを開く',
  300128: '抽選回数',
  300129: '残り（私の）',
  300130: 'オープン（合計USDT）',
  300131: 'アワード',
  300132: '遊び方',
  300133: '招待リンクを共有する',
  300134: '任務完了',
  300135: '友達を登録して、再充電とトランザクションのタスクを完了するように招待します',
  300136: 'ブラインドボックスを拾う',

  300137: 'ミッションを完了し、ブラインドボックスを取得します',
  300138: 'このイベントは終了しました。次のイベントにご期待ください。',
  300139: 'このイベントはまだ始まっていませんので、お楽しみに！',
  300140: '活動のルール',
  300141: 'はい',
  300142: '時間',
  300143: '',
  300144: '',
  300145: 'お友達紹介',
  300146: 'ジャック・オ・ランタンを灯して楽しもう<em class="normal" style="color: #FFC72B">ハロウィン</em>',
  300147: '<em class="normal" style="color: #FFC72B">{num}</em> 日間連続でサインインすると、<em class="normal" style="color: #FFC72B">{amount} ET</em> 賞品を獲得するチャンスがあります',
  300148: '受賞者一覧',
  300149: '毎日のチェックイン',

  300150: '{num} 日間ログインしています',
  300151: '宝くじ',
  300152: 'サインイン',
  300153: 'ログイン',
  300154: '',
  300155: '',
  300156: 'サインアップします',
  300157: '契約料割引クーポンをゲット!',
  300158: 'VIP アップグレード成功!',
  300159: '宝くじに当選するチャンスを得る!',

  300160: '契約金クーポン',
  300161: 'VIPアップグレード',
  300162: '',
  300163: '<em class="normal" style="color: #FFC72B">{num}</em> 回の再契約の機会があります',
  300164: 'サインアップする機会を得る',
  300165: '補充可能',
  300166: 'ヒント',
  300167: '再サインイン成功',
  300168: '何度も再申請していない場合は、その日のネットリチャージが {num} {symbol} 以上の場合に 1 回の再承認の機会を得ることができます。',
  300169: 'ログイン',

  300170: '再チェックインが上限に達しました',
  300171: '7 日間連続でサインインしたユーザーの勝者リスト',
  300172: '継続的にチェックインして、次の報酬を獲得してください',
  300173: '受け取った',
  300174: '{num} 日',
  300175: 'クーポン',
  300176: 'VIPレベル',
  300177: '抽選に参加する',
  300178: 'おめでとう！',
  300179: 'チェックイン成功',
  300180: '',
  300181: 'カレッジ',
  300182: 'ニュース',
  300183: 'データ',
  300184: '勉強',
  300185: '世界の暗号業界の主要なイベントについての洞察を得る',
  300186: '世界中の暗号業界の最新イベントを簡単に見てみましょう',
  300187: 'ブロックチェーン、Web3、および暗号通貨に関する包括的な理解',
  300188: '続きを読む',
  300189: 'ビデオ',
  300190: 'ロード中',
  300191: 'すべてがロードされました',
  300192: 'すべて',
  300193: '大会未開催',
  300194: 'ワールドカップの勝者を予想して限定  <em class="normal" style="color:#DBFF00">ボーナス</em>を獲得',
  300195: '活動時間',
  300196: '投票記録',
  300197: 'グループマッチ',
  300198: '{num}グループ',
  300199: '賞金プール：{num}',
  300200: 'サポート',
  300201: 'ノックアウト',
  300202: '昇進',
  300203: '投票締め切り残り',
  300204: '投票',
  300205: 'サポートの数を入力してください',
  300206: 'クイズの最小数：{num}ET',
  300207: 'クイズタイム',
  300208: 'チームを推測する',
  300209: '投入量',
  300210: '当選金額',
  300211: '予選チーム',
  300212: '日',
  300213: '時',
  300214: '分',
  300215: '秒',
  300216: '上映会',
  300217: 'イベントはまだ始まっていません',
  300218: '1/4決勝',
  300219: 'はい',
  300220: '支持数',
  300221: '残高が足りない',
  300222: 'コイン入金に行く',
  300223: 'クイズは成功です',
  300224: '1/8決勝',
  300225: 'セミファイナル',
  300226: '3位と4位の決勝戦',
  300227: '決勝戦',
  300228: '勝つ',
  300229: '失う',
  300230: '賞金プールの合計:{num} ET',
  300231: '試合をもっと見る',
  300232: '他のゲーム',
  300233: '通貨',
  300234: '最新価格',
  300235: '24h変動',
  300236: '初心者ガイド',
  300237: 'すぐに暗号資産取引の学習を開始します',
  300238: 'グローバルオペレーション',
  300239: '国境なし、非中央集権型コミュニティとチームはSuperEx開発の究極の形です',

  300240: '安全性0リスク',
  300241: '非中央集権型SuperWalletが統合されており、秘密鍵は暗号化されてユーザーデバイスに保存されます。コードのセキュリティ、政治などの影響を受けません。',
  300242: '登録やKYCは不要 ',
  300243: 'ウォレットの許可が与えられている限り、取引を開始でき、登録もKYCもできず、チェーン上で取引の決済が完了し、変更できず、非常に安全です',
  300244: 'オープンシステム ',
  300245: 'ユーザーがDappsまたはスマートコントラクトを使用できるようにします。 SuperWalletに入った後、ウォレットはMeta、Defi、Nftなどのさまざまなシナリオへの参加を許可されます。',
  300246: '宇宙基金',
  300247: '宇宙基金は、人間による宇宙探査、または人間による宇宙探査に多大な貢献をした機関や個人への資金に使用されます。',
  300248: '安全で使いやすいデジタル通貨市場',
  300249: 'SuperExアプリをダウンロードして、いつでもどこでも取引できます',

  300250: 'その他のダウンロード',
  300251: 'お客様のすべての取引は、火星と宇宙の人間探査を進めるのに役立ちます',
  300252: '今すぐ登録',
  300253: 'iOS & Android<br>スキャンしてダウンロード',
  300254: 'オーセンティケーター',
  300255: 'ベリファイアは2ステップ認証コードを生成します。2ステップの検証により、SuperExアカウントをより安全にすることができます。',
  300256: 'SuperEx Auth',
  300257: 'Google Auth',
  300258: 'Microsoft Auth',
  300259: 'クライアントのダウンロード (iPhone)',

  300260: 'クライアントのダウンロード (Android)',
  300261: '世界で最も信頼されているデジタル資産取引プラットフォーム',
  300262: '私たちについて',
  300263: '利用規約',
  300264: 'プライバシーポリシー',
  300265: 'アナウンスセンター',
  300266: '学習',
  300267: '初心者センター',
  300268: '現物取引',
  300269: '先物取引',

  300270: 'FAQ',
  300271: 'サービス',
  300272: 'レート標準',
  300273: '取引ルール',
  300274: 'コイン申請',
  300275: 'コミッション',
  300276: 'お問い合わせ',
  300277: 'ヘルプセンター',
  300278: 'ご要望',
  300279: 'ビジネスリエゾン',

  300280: 'ビジネス提携',
  300281: 'もっと',
  300282: 'おかえり',
  300283: 'パスワードをお忘れの方?',
  300284: 'まだアカウントを持っていませんか?',
  300285: 'パスワードをリセットするには、アプリまたはコンピューターにアクセスしてください',
  300286: 'そうですか',

  300287: '確認する',
  300288: '発表される',
  300289: '収集される',

  300290: '参加しました',
  300291: '返金した',
  300292: '購入ルール',
  300293: "クラウドショッピング <span style='color: #ffc72b;'>いいもの</span>",
  300294: '参加を買う',
  300295: '結果待ち',
  300296: '製品を受け取る',
  300297: 'バランスリチャージ',
  300298: '購入履歴',
  300299: '製品リスト',
  300300: '1回参加費',
  300301: '{num} 部が販売され、完全な {price} {currency} で購入は終了します',
  300302: '今すぐ参加',
  300303: '参加し続ける',
  300304: '購入するコピーの数を選択してください',
  300305: "1セットは<span style='color: #fa4d56;'>{minPrice} {currency}</span>必要で、1つのアイテムは最大<span style='color: #fa4d56;'>{maxBuyCount} セット</span>まで購入できます",
  300306: 'パーツ',
  300307: '{num} {currency}を持っているので、買えば買うほど当たる確率が上がる',
  300308: '購入',
  300309: '逃した機会',
  // 300309: '余额充值',
  300310: 'おめでとう',
  300311: '受け取りに行く',
  300312: '再試行する',
  300313: 'APPでリチャージまたはP2P入金操作を実行してください',
  300315: '製品を受け取るには、アプリのカスタマーサービスにお問い合わせください',
  // 300316: '我知道了',
  300317: 'ログイン 登録',
  300318: '消費{num} {currency}',
  300319: '製品説明',
  300320: '私の参加',
  300321: '時間',
  300322: '参加製品',
  300323: '購入部数',
  300324: '返金額',
  300325: '操作',
  300326: '受け取りに行く',
  300327: 'すでにアカウントをお持ちですか？',
  300328: 'ログインします',
  300329: '認証コード',
  300330: '過去 7 日間のレコードのみを表示',
  300331:'オーセンティケーター',
  300332:'ダウンロード',
  300333:'1USDTで1Bitcoinを購入可能',
  300334:"買取価格",
  300335:"過去に発表した",
  300336:"期次",
  300337:"ルールを見る",
  300338:"問題: [フェーズ {num}]",
  300339:"購入の流れ",
  300340:"成功したユーザーを獲得する",
  300341:"発表時間",
  300342:"共有",
  300343:"問題[{num}]",
  300345:"ダウンロード",
  300346:"見せびらかす",
  300347:"コードをスキャンして参加",
  300348:"製品を受け取る",
  300349:"ヒント: 仮想通貨製品は 48 時間以内にアカウントに送信されます。",
  300350:"その他の製品については、カスタマー サービスにお問い合わせください",
  300351:"チェックする",
  300352:"今すぐサインアップ",
  300353:"登録済み",
  300354:'登録は終了しました',
  300355:'サインアップ成功',
  300356:'アプリを開く',
  300357:'{shop} を獲得した {user} さん、おめでとうございます!',
  300358:'イベントセンター',
  300359:'進行中',
  300360:'開始しようとしています',
  300361:'終わった',
  300362:'今すぐ参加する',
  300363: '終わった',
  300364: '勝者',
  300365: '受賞者はまもなく発表されます',


  310000:'報酬の概要',
  310001:'SCS エアドロップ',
  300366: '通貨',
  300367: '売る',
  200368: '支払い',
  300369: '受け取る',
  300370: '得る',
  300371: '回のお取引限度額：',
  300372: '支払方法',
  300373: '支払方法',
  300374: '支払いチャネル',
  300375: '注文詳細',
  300376: '金額（取引手数料含む）',
  300377: '到着時刻',
  300378: '免責事項',
  300379: '私は免責事項を読み同意しました',
  300380: "す。これは、サードパーティとして銀行カードによる支払い機能を提供する認可を受けた金融機関です。 使用中に発生した危険事象は<span>{name}</span>が負担します。 <span>{name}</span>サービスをご利用になる前に、<a class='pointer' href={server}>サービス利用規約</a>をよくお読みいただき、同意してください。クレジット カード デポジットについてご質問がある場合は、詳細について <a class='pointer' href={Customer}>{name} カスタマー サービス</a> までお問い合わせください。",
  300381: 'SuperEx で暗号通貨を購入するにはどうすればよいですか?',
  300382: 'SuperEx で暗号通貨を販売する方法？',
  300383: '暗号通貨の注文をする',
  300384: '支払いたい法定通貨と購入したい暗号通貨を選択します。 使いたい金額を入力します。',
  300385: '身元を確認する',
  300386: 'SuperEx と決済プロバイダーで KYC 検証を完了して、支払いを完了します。',
  300387: '注文内容を確認する',
  300388: '入金履歴を確認して、注文のステータスを確認してください。',
  300389: 'FAQ',
  300390: '1. 暗号通貨の購入にはどのような支払い方法を使用できますか?',
  300391: 'SuperEx は現在、VISA、Mastercard、Apple Pay、Google Pay およびその他の支払い方法をサポートしています。 サポートされているサードパーティ サービス プロバイダーには、Mercuryo、alchemypay が含まれます。',
  300392: '2. どの仮想通貨を購入できますか?',
  300393: 'SuperEx は、BTC、ETH、USDT、LTC、USDC、XRP、BCH、CRV、TRX およびその他の主流の暗号通貨をサポートしています。',
  300394: '3. SuperEx は、サポートされているサードパーティ サービス プロバイダーの品質と価格を監視していますか?',
  300395: 'SuperEx は、ユーザーにプロセス指向のサービスを提供するために、信頼できる業界での評判、人気、セキュリティを備えたサービス プロバイダーのグループを慎重に選択しました。',
  300396: '4. 暗号通貨の購入手数料はいくらですか?',
  300397: 'サードパーティのサービスプロバイダーに料金とオンチェーン転送を支払います。 SuperEx では手数料はかかりません。',
  300398: '5. 支払い後、暗号通貨を受け取るまでにどのくらい時間がかかりますか?',
  300399: 'サードパーティのサービス プロバイダー プラットフォームで支払いを完了すると、約 2 ～ 10 分以内に暗号通貨が SuperEx スポット アカウントに入金されます。',
  300400: '6. 購入プロセス中に問題が発生した場合はどうすればよいですか?',
  300401: '取引中に問題が発生した場合は、カスタマーサポートまでご連絡ください。 支払い完了後に暗号通貨を受け取っていない場合は、サードパーティのサービスプロバイダーに連絡して注文の詳細を確認してください (通常、これが最も効率的な方法です)。 現在の地域の IP またはいくつかのポリシー上の理由により、手動検証を選択する必要があります。',
  300402: "利用可能な残高",
  300403: '残高不足',
  300404: '通貨を入力してください',
  300405: '法定通貨を入力してください',
  300406: '本人確認が完了していません',
  300407: "取引ユーザーとのアカウントのセキュリティのために、最初に身元認証を完了してください",
  300408: '認証に行く',
  300409: 'まだ認定されていません',
  300410: '通貨を選択してください',
  300411: '法定通貨を選択',
  300412: 'すべての通貨',
  300413: 'すべてのフィアット',
  300414: '≈{time} minutes',
  300415: 'P2P トランザクションは一時的にウォレットの承認されたユーザーに公開されていません。P2P トランザクションを行うには SuperEx アカウントでログインしてください',
  300416: 'https://support.superex.com/hc/en-001/articles/23084120565017',
  300417:'買う',
  300418: 'シーケンス番号',
  300419: 'SuperEx ハロウィーンアクティビティ',
  300420: 'サインインして素晴らしいギフトを楽しんだり、トレードしてボーナスを獲得しましょう!',
  ...jaLocal
}
export default ja;



// WEBPACK FOOTER //
// ./src/i18n/langs/ja.js